import Box from '@zenbusiness/zui/Box';
import Card from '@zenbusiness/zui/Card';
import SharedAsset from '@zenbusiness/zui/SharedAsset';
import Stack from '@zenbusiness/zui/Stack';
import { styled } from '@zenbusiness/zui/styles';

export const Container = styled(Card)(({ theme, color }) => {
  let bgrColor;

  switch (color) {
    case 'green':
      bgrColor = theme.palette.background.green.light;
      break;
    case 'blue':
    default:
      bgrColor = theme.palette.background.blue.light;
  }

  return {
    background: `linear-gradient(0deg, var(--background-accent-wisdom-10-info, ${bgrColor}) -89.14%, ${theme.palette.background.grey.light} 61.48%)`,
    borderRadius: theme.shape.rounded.lg,
    borderColor: theme.palette.border.main,

    [theme.breakpoints.up('sm')]: {
      background: `linear-gradient(268deg, var(--background-accent-wisdom-10-info, ${bgrColor}) -69.82%, ${theme.palette.background.grey.light} 58.94%)`,
    },
  };
});

export const Image = styled(SharedAsset)(({ theme }) => ({
  objectFit: 'cover',

  [theme.breakpoints.up('sm')]: {
    minHeight: '11rem',
    objectPosition: 'top',
  },
}));

export const LogoContainer = styled(Box)(({ theme }) => ({
  width: '2.625rem',
  height: '2.625rem',

  [theme.breakpoints.up('md')]: {
    width: '3rem',
    height: '3rem',
  },
}));

export const BannerContent = styled(Stack)(({ theme }) => ({
  position: 'absolute',
  top: 0,
  left: 0,
  padding: theme.spacing(3),
  width: '100%',
  height: '40%',
  minHeight: 'fit-content',
  gap: theme.spacing(0.5),
  justifyContent: 'center',
  alignItems: 'flex-start',

  [theme.breakpoints.up('sm')]: {
    padding: `${theme.spacing(2)} ${theme.spacing(3)}`,
    width: '400px',
    height: '100%',
  },

  [theme.breakpoints.up('lg')]: {
    paddingLeft: theme.spacing(5),
    width: '570px',
  },
}));
